/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://5pjdpi7wi8.execute-api.us-east-2.amazonaws.com/kempinski",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://2zvjfnvxlvapnlyqxiyu72yjgq.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-hxyymm7hmnam7jrr5d5dlpvimy",
    "aws_cognito_identity_pool_id": "us-east-2:d12b5c9d-165b-4d03-bfe2-b6d2850305bd",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_yym8FeRv6",
    "aws_user_pools_web_client_id": "4m6bvi3k8g9p7tdl69tq7eojpf",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
